// ─────────────────────────────────────────────────────────────────────────────
// SUPPORT TEAM CONFIGURATION
// Edit this file to add/remove managers, CEs, vendors and region mappings
// ─────────────────────────────────────────────────────────────────────────────

// ── Service Managers ──────────────────────────────────────────────────────────
export const SERVICE_MANAGERS = [
  {
    id:       'mgr_chennai_001',
    name:     'Ayesha Khan',
    email:    'ayeshakhan@hoags.in',
    phone:    '9841000001',
    region:   'Chennai',
    regions:  ['chennai', 'salem', 'coimbatore', 'madurai', 'trichy', 'vellore'],
    // Full access — sees every sidebar tab (Dashboard/Recharge/Analytics/
    // Miscellaneous/Support/Role Management), unlike other managers who
    // default to just Miscellaneous + Role Management.
    permissions: ['all'],
  },
  {
    id:       'mgr_delhi_001',
    name:     'Aman Sodhi',
    email:    'Aman@hoags.in',
    phone:    '9811000001',
    region:   'Delhi',
    regions:  ['delhi', 'noida', 'gurgaon', 'faridabad', 'ghaziabad'],
  },
  {
    id:       'mgr_mumbai_001',
    name:     'Ravi Shankar',
    email:    'ravi.shankar@hoags.in',
    phone:    '9900000003',
    region:   'Mumbai',
    regions:  ['mumbai', 'thane', 'navi mumbai', 'pune'],
  },
  {
    id:       'mgr_hyderabad_001',
    name:     'Pradeep Kumar',
    email:    'pradeep.kumar@hoags.in',
    phone:    '9900000004',
    region:   'Hyderabad',
    regions:  ['hyderabad', 'secunderabad', 'warangal'],
  },
  {
    id:       'mgr_chennai2_001',
    name:     'Divya Menon',
    email:    'divya.menon@hoags.in',
    phone:    '9900000005',
    region:   'Karnataka',
    regions:  ['bangalore', 'mysore', 'hubli', 'mangalore', 'belgaum'],
  },
];

// ── Customer Engineers (CE) ───────────────────────────────────────────────────
// 5 CEs per manager, matching the dummy team structure (CE-01..CE-25)
export const CUSTOMER_ENGINEERS = [
  // Manager 1 — Ayesha Khan (Chennai)
  { id:'ce_chennai_001', name:'Suresh Kumar', email:'suresh.ce@hoags.in', phone:'9841100001', region:'Chennai', manager_id:'mgr_chennai_001', code:'CE-01' },
  { id:'ce_chennai_002', name:'Priya Devi',   email:'priya.ce@hoags.in',  phone:'9841100002', region:'Chennai', manager_id:'mgr_chennai_001', code:'CE-02' },
  { id:'ce_chennai_003', name:'Karthik Raja', email:'ce03@hoags.in',      phone:'9841100003', region:'Chennai', manager_id:'mgr_chennai_001', code:'CE-03' },
  { id:'ce_chennai_004', name:'Lakshmi Narayanan', email:'ce04@hoags.in', phone:'9841100004', region:'Chennai', manager_id:'mgr_chennai_001', code:'CE-04' },
  { id:'ce_chennai_005', name:'Mohan Das',    email:'ce05@hoags.in',      phone:'9841100005', region:'Chennai', manager_id:'mgr_chennai_001', code:'CE-05' },

  // Manager 2 — Aman Sodhi (Delhi)
  { id:'ce_delhi_001', name:'Rahul Sharma',   email:'rahul.ce@hoags.in',  phone:'9811100001', region:'Delhi', manager_id:'mgr_delhi_001', code:'CE-06' },
  { id:'ce_delhi_002', name:'Neha Gupta',     email:'ce07@hoags.in',      phone:'9811100002', region:'Delhi', manager_id:'mgr_delhi_001', code:'CE-07' },
  { id:'ce_delhi_003', name:'Vikas Yadav',    email:'ce08@hoags.in',      phone:'9811100003', region:'Delhi', manager_id:'mgr_delhi_001', code:'CE-08' },
  { id:'ce_delhi_004', name:'Pooja Mehta',    email:'ce09@hoags.in',      phone:'9811100004', region:'Delhi', manager_id:'mgr_delhi_001', code:'CE-09' },
  { id:'ce_delhi_005', name:'Sanjay Verma',   email:'ce10@hoags.in',      phone:'9811100005', region:'Delhi', manager_id:'mgr_delhi_001', code:'CE-10' },

  // Manager 3 — Mumbai
  { id:'ce_mumbai_001', name:'Rohan Patil',   email:'ce11@hoags.in', phone:'9900100001', region:'Mumbai', manager_id:'mgr_mumbai_001', code:'CE-11' },
  { id:'ce_mumbai_002', name:'Sneha Joshi',   email:'ce12@hoags.in', phone:'9900100002', region:'Mumbai', manager_id:'mgr_mumbai_001', code:'CE-12' },
  { id:'ce_mumbai_003', name:'Aditya Rane',   email:'ce13@hoags.in', phone:'9900100003', region:'Mumbai', manager_id:'mgr_mumbai_001', code:'CE-13' },
  { id:'ce_mumbai_004', name:'Komal Shinde',  email:'ce14@hoags.in', phone:'9900100004', region:'Mumbai', manager_id:'mgr_mumbai_001', code:'CE-14' },
  { id:'ce_mumbai_005', name:'Vivek Naik',    email:'ce15@hoags.in', phone:'9900100005', region:'Mumbai', manager_id:'mgr_mumbai_001', code:'CE-15' },

  // Manager 4 — Hyderabad
  { id:'ce_hyderabad_001', name:'Srinivas Reddy', email:'ce16@hoags.in', phone:'9900200001', region:'Hyderabad', manager_id:'mgr_hyderabad_001', code:'CE-16' },
  { id:'ce_hyderabad_002', name:'Anitha Rao',     email:'ce17@hoags.in', phone:'9900200002', region:'Hyderabad', manager_id:'mgr_hyderabad_001', code:'CE-17' },
  { id:'ce_hyderabad_003', name:'Praveen Kumar',  email:'ce18@hoags.in', phone:'9900200003', region:'Hyderabad', manager_id:'mgr_hyderabad_001', code:'CE-18' },
  { id:'ce_hyderabad_004', name:'Divya Sree',     email:'ce19@hoags.in', phone:'9900200004', region:'Hyderabad', manager_id:'mgr_hyderabad_001', code:'CE-19' },
  { id:'ce_hyderabad_005', name:'Naveen Goud',    email:'ce20@hoags.in', phone:'9900200005', region:'Hyderabad', manager_id:'mgr_hyderabad_001', code:'CE-20' },

  // Manager 5 — Chennai-South
  { id:'ce_chennai2_001', name:'Bala Murugan', email:'ce21@hoags.in', phone:'9900300001', region:'Karnataka', manager_id:'mgr_chennai2_001', code:'CE-21' },
  { id:'ce_chennai2_002', name:'Revathi S',    email:'ce22@hoags.in', phone:'9900300002', region:'Karnataka', manager_id:'mgr_chennai2_001', code:'CE-22' },
  { id:'ce_chennai2_003', name:'Dinesh Babu',  email:'ce23@hoags.in', phone:'9900300003', region:'Karnataka', manager_id:'mgr_chennai2_001', code:'CE-23' },
  { id:'ce_chennai2_004', name:'Kavitha M',    email:'ce24@hoags.in', phone:'9900300004', region:'Karnataka', manager_id:'mgr_chennai2_001', code:'CE-24' },
  { id:'ce_chennai2_005', name:'Arun Prakash', email:'ce25@hoags.in', phone:'9900300005', region:'Karnataka', manager_id:'mgr_chennai2_001', code:'CE-25' },
];

// ── Vendors / Field Technicians ───────────────────────────────────────────────
export const VENDORS = {
  Chennai: [
    { id: 'vnd_chn_001', name: 'Ravi Plumbing',      phone: '9841023456', specialty: 'Plumbing & Water Lines' },
    { id: 'vnd_chn_002', name: 'Suresh Water Works', phone: '9962034567', specialty: 'Purifier Service' },
    { id: 'vnd_chn_003', name: 'Anand Tech',         phone: '9790145678', specialty: 'Electronics & PCB' },
    { id: 'vnd_chn_004', name: 'Kiran Service',      phone: '9444256789', specialty: 'General Service' },
  ],
  Delhi: [
    { id: 'vnd_del_001', name: 'Rajesh Aqua',  phone: '9811367890', specialty: 'Water Purifier Expert' },
    { id: 'vnd_del_002', name: 'Priya Water',  phone: '9873478901', specialty: 'Plumbing & Piping' },
    { id: 'vnd_del_003', name: 'Amit Tech',    phone: '9654589012', specialty: 'Electronics Repair' },
    { id: 'vnd_del_004', name: 'Vikram Field', phone: '9910690123', specialty: 'General Field Service' },
  ],
  Mumbai: [
    { id: 'vnd_mum_001', name: 'Bombay Aqua Services', phone: '9820012345', specialty: 'Water Purifier Expert' },
    { id: 'vnd_mum_002', name: 'Patel Plumbing',        phone: '9820023456', specialty: 'Plumbing & Piping' },
    { id: 'vnd_mum_003', name: 'Shinde Electronics',    phone: '9820034567', specialty: 'Electronics Repair' },
  ],
  Hyderabad: [
    { id: 'vnd_hyd_001', name: 'Reddy Aqua Care',     phone: '9849012345', specialty: 'Water Purifier Expert' },
    { id: 'vnd_hyd_002', name: 'Charminar Plumbing',  phone: '9849023456', specialty: 'Plumbing & Piping' },
    { id: 'vnd_hyd_003', name: 'Tech Solutions HYD',  phone: '9849034567', specialty: 'Electronics Repair' },
  ],
  Karnataka: [
    { id: 'vnd_chs_001', name: 'Bangalore Aqua Care', phone: '9962100001', specialty: 'Purifier Service' },
    { id: 'vnd_chs_002', name: 'Mysore Tech Services', phone: '9962100002', specialty: 'Electronics & PCB' },
  ],
};

// ── Region → Manager auto-assign mapping ─────────────────────────────────────
// Key: lowercase location string from device registration
// Value: manager ID from SERVICE_MANAGERS above
export const REGION_MANAGER_MAP = {};

// Build the map automatically from SERVICE_MANAGERS
SERVICE_MANAGERS.forEach(mgr => {
  mgr.regions.forEach(region => {
    REGION_MANAGER_MAP[region.toLowerCase()] = mgr.id;
  });
});

// ── Helper functions ──────────────────────────────────────────────────────────

/** Get manager for a device location */
export function getManagerForLocation(location = '') {
  const loc = location.toLowerCase().trim();
  // Exact match first
  if (REGION_MANAGER_MAP[loc]) return REGION_MANAGER_MAP[loc];
  // Partial match (e.g. "Salem, Tamil Nadu" → "salem")
  const match = Object.keys(REGION_MANAGER_MAP).find(key => loc.includes(key));
  return match ? REGION_MANAGER_MAP[match] : null;
}

/** Get manager object by ID */
export function getManagerById(id) {
  return SERVICE_MANAGERS.find(m => m.id === id) || null;
}

/** Get CE object by ID */
export function getCEById(id) {
  return CUSTOMER_ENGINEERS.find(ce => ce.id === id) || null;
}

/** Get all CEs under a manager */
export function getCEsForManager(managerId) {
  return CUSTOMER_ENGINEERS.filter(ce => ce.manager_id === managerId);
}

/** Get vendors for a region */
export function getVendorsForRegion(region = '') {
  const key = Object.keys(VENDORS).find(k => k.toLowerCase() === region.toLowerCase());
  return key ? VENDORS[key] : [];
}

/** Get manager object by email */
export function getManagerByEmail(email = '') {
  return SERVICE_MANAGERS.find(m => m.email.toLowerCase() === email.toLowerCase()) || null;
}

/** Get CE object by email */
export function getCEByEmail(email = '') {
  return CUSTOMER_ENGINEERS.find(ce => ce.email.toLowerCase() === email.toLowerCase()) || null;
}

/** All managers with their CE count (for Admin overview) */
export function getManagerSummaries() {
  return SERVICE_MANAGERS.map(mgr => ({
    ...mgr,
    ceCount: getCEsForManager(mgr.id).length,
  }));
}
